<template>
<!-- <v-layout class="overflow-visible"> -->
    <v-bottom-navigation 
        v-model="value"
        color="primary"
        horizontal
        :elevation="0"
        :height="109"
        class="informationSelectFooter"
        >
            <div 
                class="buttonContainer"
                :class="{'active': menuMode == 'risk' || menuMode == null}"
                v-if="riskIsValid"
            >

                <v-img :src="require('@/assets/icons/star.svg')" class="icon star" 
                    v-if="menuMode != 'risk' && menuMode != null"
                    @click="setMennuMode('risk')"
                />
                <v-img :src="require('@/assets/icons/star_red.svg')" class="icon star" 
                    v-if="menuMode == 'risk' || menuMode == null"
                    @click="setMennuMode('risk')"
                />

                <v-btn class="menuButton"
                    @click="setMennuMode('risk')"
                    :ripple="false"
                >
                    Risk
                </v-btn>
            </div>
            <div
                class="buttonContainer"
                v-if="keyFiguresIsValid"
                :class="{'active': menuMode == 'keyFigures'}"
            >
                <v-img :src="require('@/assets/icons/graph.svg')" class="icon graph" 
                    v-if="menuMode != 'keyFigures'"
                    @click="setMennuMode('keyFigures')"
                />

                <v-img :src="require('@/assets/icons/graph_red.svg')" class="icon graph" 
                    v-if="menuMode == 'keyFigures'"
                    @click="setMennuMode('keyFigures')"
                />
                <v-btn class="menuButton"
                    @click="setMennuMode('keyFigures')"
                    :ripple="false"
                >
                    Figures
                </v-btn>
            </div>
            <div 
                class="buttonContainer"
                v-if="esgIsValid"
                :class="{'active': menuMode == 'esg'}"
            >
                <v-img src="@/assets/icons/eco.svg" class="icon eco" 
                    v-if="menuMode != 'esg'"
                    @click="setMennuMode('esg')"
                />
                <v-img src="@/assets/icons/eco_red.svg" class="icon eco" 
                    v-if="menuMode == 'esg'"
                    @click="setMennuMode('esg')"
                />
                <v-btn class="menuButton"
                    @click="setMennuMode('esg')"
                    :ripple="false"
                >
                    ESG
                </v-btn>
            </div>
            <div
                class="buttonContainer"
                v-if="industryIsValid"
                :class="{'active': menuMode == 'industry'}"
            >
                <v-img src="@/assets/icons/arrow.svg" class="icon arrow" 
                    v-if="menuMode != 'industry'"
                    @click="setMennuMode('industry')"
                />

                <v-img src="@/assets/icons/arrow_red.svg" class="icon arrow" 
                    v-if="menuMode == 'industry'"
                    @click="setMennuMode('industry')"
                />

                <v-btn class="menuButton"
                    @click="setMennuMode('industry')"
                    :ripple="false"
                >
                    Industry
                </v-btn>
            </div>

    </v-bottom-navigation>
<!-- </v-layout> -->
</template>

<script >
import store from '@/store';
import {Service as CountryService} from '../../services/countryService';
export default {
    data() {
        return {
            // menuMode: 'risk',
            riskIsValid: false,
            keyFiguresIsValid: false,
            esgIsValid: false,
            industryIsValid: false,
        };
    },
    mounted() {
        // 
    },
    computed:{
        menuMode(){
            const menuMode = store.getters['stateStoreData/menuMode'];
            if(menuMode){
                return menuMode.trim();
            }else{
                return menuMode;
            }
        },
        selectedCountry(){
            return store.getters['countryStoreData/selectedCountry'];
        }
        
    },
    methods: {
        setMennuMode(value) {
            store.dispatch('stateStoreData/setMenuMode', value);
        }
    },
    watch: {
        menuMode: {
            immediate: true,
            deep: true,
            handler(val) {
                // this.menuMode = val;
        
            }
        },
        selectedCountry: {
            immediate: true,
            deep: true,
            handler(val) {
                if (val) {
                    this.riskIsValid = CountryService.hasRiskData(val);
                    this.keyFiguresIsValid = CountryService.hasKeyFiguresData(val);
                    this.esgIsValid = CountryService.hasESGData(val);
                    this.industryIsValid = CountryService.hasIndustryPerformanceData(val);
                }
            }
        }
    }
}
</script>

<style>
.informationSelectFooter {
}

.informationSelectFooter .icon {
    width: 28px;
    height: 28px;
    margin: auto;
    /* display: block; */
}

.informationSelectFooter  .icon.arrow {
    width: 25px;
    height: 23px;
    /* margin-bottom: 3px; */
    /* margin-top:2px ; */
}

.informationSelectFooter .menuButton {
    height: 0;
    text-align: center;
    /* margin-top: 5px; */
    /* margin-bottom: 15px; */
    font-family: 'GCO Sans', sans-serif !important;
    text-transform: capitalize !important;
    padding-top: 1em;
    font-size: 12px;
    font-weight: 400;
    line-height: 19px;
    text-align: center;
    letter-spacing: 0.48px;
}

.informationSelectFooter .menuButton .v-btn__content{
    margin-top: -10px;
}
/* .informationSelectFooter .v-bottom-navigation {
    height: 100px !important;
    box-shadow: none;
} */

.informationSelectFooter .v-btn__overlay{
    opacity: 0 !important;
}

.buttonContainer {
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    /* align-items: center; */
    width: 22%;
    height: 70%;
    padding-top: 20px;
    cursor: pointer;
}
</style>
